
import { useTranslation } from "react-i18next";
import NewPage from "../../../layouts/page/NewPage";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { convertBooleanToStatus } from "../../../../utils/ConverterUtils";
import MenuConfig from "../../../../constants/MenuConfig";
import Form from "./Form";
import { getId, sendToApi } from "../../../../utils/ApiUtils";
import { useNavigate } from "react-router-dom";
import Api from "../../../../constants/Api";
import { ApiError } from "../../../components/Common/ApiError";

const VendorNew = () => {

    const { t } = useTranslation();
    const [status, setStatus] = useState(true);
    const [entityData, setEntityData] = useState(null);
    const navigate = useNavigate();

    // Define o schema de validação do form.
    const formSchema = Yup.object().shape({
        name: Yup.string()
            .min(3, t("validation.min.generic", { field: t('name'), qty: 3 }))
            .required(t('validation.required.name'))
    });

    // Define o formik.
    const formik = useFormik({
        initialValues: {
            name: '',
            corporateName: '',
            phone: '',
            document: '',
            email: '',
            obs: '',
            status: true,
            street: '',
            number: '',
            complement: '',
            neighborhood: '',
            city: '',
            state: '',
            zipCode: ''
        },
        validationSchema: formSchema,
        onSubmit: values => {
            let payload = {
                id: getId(entityData),
                name: values.name,
                corporateName: values.corporateName,
                phone: values.phone,
                document: values.document,
                email: values.email,
                address: {
                    street: values.street,
                    number: values.number,
                    complement: values.complement,
                    neighborhood: values.neighborhood,
                    city: values.city,
                    state: values.state,
                    zipCode: values.zipCode
                },
                obs: values.obs,
                status: convertBooleanToStatus(status),
            }

            // Aciona a api
            sendToApi(Api.main.vendor, payload, () => {
                if (entityData == null) {
                    onReset();
                } else {
                    navigate(MenuConfig.main.vendor.route);
                }
            }, (error) => {
                ApiError(error);
                formik.setSubmitting(false);
            });
        }
    });

    // Valida o form e em seguida submete os dados. Aciona o onSubmit do formik.
    const onSubmit = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    }

    const onReset = () => {
        formik.resetForm();
        setStatus(true);
    }

    return (
        <>
            <NewPage
                motherMenu={t('main')}
                childMenu={t('vendors')}
                activeMenu={t('new')}
                child={
                    <Form
                        formik={formik}
                        status={status}
                        setStatus={setStatus}
                        entityData={entityData}
                    />
                }
                setEntityData={setEntityData}
                path={Api.main.vendor}
                isSubmitting={formik.isSubmitting}
                handleSubmit={onSubmit}
                cancelRoute={MenuConfig.main.vendor.route}
            />
        </>
    );
}

export default VendorNew;